'use strict';

import React, { Fragment } from 'react';

import QuickSearchBase from './QuickSearchBase';
import ExtendSearch from '../ExtendSearch/RentApartments';
import { RENT, APARTMENTS } from '../../../consts';
import { Checkbox } from '../../Controls';

class RentApartments extends QuickSearchBase {
  constructor (props) {
    super(props);

    this.handlerMls = this.handlerMls.bind(this);
  }

  hasMls () {
    const userExist = this.getUserId() > 0;
    const hasMls = this.props.user.getIn(['data', 'hasMls'], false) || false;

    return userExist && hasMls;
  }

  handlerMls (id, select) {
    const filter = {
      isMls: (select ? 1 : null)
    };

    if (select) {
      filter.onlyOwners = null;
    } else {
      filter.withoutComplaint = null;
    }
    this.props.onUpdate(filter);
  }

  render () {
    return (
      <Fragment>
        <div className='flex flex-items-center quick-search-rent-apartments' onKeyPress={this.onPressEnterExtendFilter}>
          { this.renderObjectType(RENT, APARTMENTS, 'Тип жилья') }
          { this.renderTerritorialDivision() }
          { this.renderAutocompleteLocation() }
          { this.renderPriceGroup(false) }

          { this.renderExtendSearch(ExtendSearch) }
        </div>

        <div className='flex flex-items-center quick-search__sub-filter'>
          <div className='quick-search__sub-filter-left'>
            <Checkbox
              label='Без комиссии'
              disabled={!!this.getValue('isMls')}
              checked={this.getValue('onlyOwners')}
              onUpdate={(_, state) => {
                const filter = {
                  onlyOwners: state ? 1 : null
                };

                if (state) {
                  filter.isMls = null;
                }

                this.props.onUpdate(filter);
              }}
            />
            {this.hasMls() && <Checkbox
              label='МЛС'
              checked={this.getBool('isMls')}
              onUpdate={this.handlerMls}
            />}

            {this.hasMls() && <Checkbox
              label='Без жалоб'
              disabled={!this.getBool('isMls')}
              checked={this.getBool('withoutComplaint')}
              onUpdate={this.handlerCheckbox('withoutComplaint')}
            />}
            <Checkbox
              label='С фото'
              checked={this.getValue('hasPhoto')}
              onUpdate={this.handlerCheckbox('hasPhoto')}
            />
          </div>
          <div className='quick-search__sub-filter-right'>
            { this.renderSubmitMap() }
            { this.renderSubmit() }
          </div>
        </div>

        { this.renderPills(RENT, APARTMENTS) }
      </Fragment>
    );
  }
}

export default RentApartments;



// WEBPACK FOOTER //
// ./src/ui/Search/QuickSearch/RentApartments.jsx